import React, { useState } from "react";
import { Link } from "react-router-dom";
import openIcon from "shared/assets/images/svg/external_arrow.svg";
import Person from 'shared/assets/images/png/icons8-person-64.png'
import BookingModal from "./popUp/bookingModal";
import { BookingOfficeSourceAtom } from "./popUp/office-booking.service";
import { useRecoilValue } from "recoil";
import useModal from "shared/hooks/useModel";
import BalanceModal from "./popUp/balanceModal";
import { BalanceOfficeSourceAtom } from "./popUp/office-balance.service";

const BoxControl = ({item}) => {
  const [showBooking, openBooking, closeBooking] = useModal(false);
  const [showBanlance, openBanlance, closeBanlance] = useModal(false);

  const bookingOfficeSource = useRecoilValue(BookingOfficeSourceAtom(item.id))
  const balanceOfficeSource = useRecoilValue(BalanceOfficeSourceAtom(item.id))


  return (
    <>
    <div className="box-control2">
      <div className="logo">
        <img src={Person} alt="p"/>
      </div>
      <div className="info">
        <div className="name">
          <h1 className="title">{item.name}</h1>
          <div className="view">
            <button onClick={openBooking}  >Tickets</button>
            <button onClick={openBanlance}  >Transactions</button>

          </div>
        </div>
        <div className="price">
          <h1>{parseFloat(`${item.balance}`).toFixed(2)} <span>SAR</span></h1>
        </div>
      </div>
    </div>
    <BookingModal show={showBooking} onHide={closeBooking} bookingOfficeSource={bookingOfficeSource} name={item.name}/>
    <BalanceModal show={showBanlance} onHide={closeBanlance} bookingOfficeSource={balanceOfficeSource} name={item.name}/>

    </>
  );
};

export default BoxControl;
